module.exports = __webpack_public_path__ + "img/UpDay CIC.e449a438.svg";